import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Formation from './components/Formation';
import Parcours from './components/Parcours';
import Financement from './components/Financement';
import Equipe from './components/Equipe';
import RessourcesPage from './components/RessourcesPage';
import ArticleFpaRncp from './components/ArticleFpaRncp';
import ArticleGeneseEnjeux from './components/ArticleGeneseEnjeux';
import ArticleNouvelleGeneration from './components/ArticleNouvelleGeneration';
import ArticleGrandEcartPrix from './components/ArticleGrandEcartPrix';
import ArticleFinancerFormation from './components/ArticleFinancerFormation';
import MentionsLegales from './components/MentionsLegales';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <Formation />
              <Parcours />
              <Financement />
              <Equipe />
            </>
          } />
          <Route path="/ressources" element={<RessourcesPage />} />
          <Route path="/ressources/titre-fpa-rncp37275" element={<ArticleFpaRncp />} />
          <Route path="/ressources/genese-enjeux-titre-rncp37275" element={<ArticleGeneseEnjeux />} />
          <Route path="/ressources/nouvelle-generation-formateurs" element={<ArticleNouvelleGeneration />} />
          <Route path="/ressources/rncp37275-grand-ecart-prix-formation" element={<ArticleGrandEcartPrix />} />
          <Route path="/ressources/rncp37275-financer-formation" element={<ArticleFinancerFormation />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
